/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
export const environment = {
  production: true,
  VERSION: require('../../package.json').version,
  packageDate: '20260312',
  testMode: false,
  PROD_API_SERVER_ADDRESS: 'https://researcharsenal-webapi.azurewebsites.net',
  TESTING_API_SERVER_ADDRESS: 'https://researcharsenal-webapi-testing.azurewebsites.net',
  TESTING_UPLOADER_VM_API_SERVER_ADDRESS: 'https://imageuploader-testing.researcharsenal.com:444',
  PROD_UPLOADER_VM_API_SERVER_ADDRESS: 'https://imageuploader.researcharsenal.com',
  supportEmailAddress: 'support@researcharsenal.com',
  testSupportEmailAddress: 'researchsupport@starbase.app',
  appInsights_InstrumentationKey: '6ed0c94a-55bc-4ff4-bfa5-acb3ba49bb76', // prod
  //appInsights_InstrumentationKey: '3efd9f10-6414-4263-8875-815e1c1843ab', // testing
  squareApi: {
    testing: { // sandbox
      appId: 'sandbox-sq0idb-01cCHcj833uK-41VyIbNiQ',
      locationId: 'LGWQMB9PS2K2Q',
      scriptName: 'Square-sandbox',
      scriptUrl: 'https://sandbox.web.squarecdn.com/v1/square.js'
    },
    production: {
      appId: 'sq0idp-NHSwZ6w7e-a9r2I-r-o1Lg',
      locationId: 'LA5S3RWK29X5B',
      scriptName: 'Square-production',
      scriptUrl: 'https://web.squarecdn.com/v1/square.js'
    }
  },
  syncFusion: {
    // eslint-disable-next-line max-len
    license: 'ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5Wd0diX3xadXFXQmNbWkZ1'
  },
  typeOfImageIds: {
    'Ordnance_Returns': 2,
    'Photos': 4,
    'Letters & Diaries': 5,
    'Unspecified': 6,
    'Quartermaster_Report_of_Animals': 7,
    'Morning_Reports': 8,
    'General_Special_Orders': 9,
    'Payroll_Documents': 10,
    'Muster_Rolls': 11,
    'Contracts': 12,
    'Quartermaster_Manuals': 13,
    'No_33:_Requisition_for_Forage': 14,
    'No. 2(b): Invoice of Ordnance and Ordnance Stores': 15,
    'No. 52: Receipt Roll for Clothing': 16,
    'No. 3(a): For Issues of Ordnance Stores': 17,
    'No. 36: Requisition Sheet': 18,
    'No. 7(a): For issues or Transfers of Ordnance Stores': 19,
    'No. 27: List of Clothing, Camp, and Garrison Equipage': 20,
    'No. 40: Special Requisitions': 21,
    'No. 6: Consolidated Provision Return': 22,
    'No. 1: Abstract of issues to the Volunteers & Militia': 23,
    'Report of State of Regiment*': 24,
    'Report of Sick and Wounded': 25,
    'Articles Lost or Destroyed in the Public Service*': 26,
    'Invoice of Subsistence Stores*': 27,
    'Ordnance Returns: Return of Ordnance Stores': 28,
    'Quartermaster Returns: Inventory & Inspection of Quartermaster Property': 29,
    'No. 51: Monthly Return of Clothing, Camp, and Garrison Equipage': 30,
    'No. 45: List of Stores Transferred to': 31,
    'Clothing_Ledger/Books': 32
  },
  nationalArchivesId: 7,
  subscriptions: {
    'Student': 2,
    'Monthly': 3,
    'Annual': 4
  },
  recaptcha: {
    siteKey: '6LeRkwUrAAAAAMdgWbU95IwncPXcNvaKOpZnPHpl'
  }

};
